import { render, staticRenderFns } from "./cartTable.vue?vue&type=template&id=2b8b3e18&scoped=true&"
import script from "./cartTable.vue?vue&type=script&lang=js&"
export * from "./cartTable.vue?vue&type=script&lang=js&"
import style0 from "./cartTable.vue?vue&type=style&index=0&id=2b8b3e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b3e18",
  null
  
)

export default component.exports